/** Enforces sequential (one at a time) fetch execution */
export class SequentialFetchQueue {
    constructor(fetch, timeout, queueTimeout) {
        this.requestInProgress = false;
        this.queuedRequests = [];
        if (fetch == null) {
            throw new Error('No request.');
        }
        this.fetch = fetch;
        this.fetchTimeout = timeout;
        this.queueTimeout = queueTimeout;
    }
    tryProcessNextRequest() {
        this.requestInProgress = false;
        if (this.queuedRequests.length > 0) {
            const [request, callback, timer] = this.queuedRequests.shift();
            clearTimeout(timer);
            this.add(request, callback);
        }
    }
    add(request, callback) {
        if (this.requestInProgress) {
            const queuedRequestsTimeout = setTimeout(() => {
                callback(new Error('Timed out waiting in queue'), null);
                this.queuedRequests.shift();
            }, this.queueTimeout);
            this.queuedRequests.push([request, callback, queuedRequestsTimeout]);
        }
        else {
            this.requestInProgress = true;
            const fetchWrapperPromise = new Promise((resolve, reject) => {
                let didTimeout = false;
                const timeout = setTimeout(() => {
                    didTimeout = true;
                    reject(new Error('Fetch timed out'));
                }, this.fetchTimeout);
                this.fetch(request)
                    .then((response) => {
                    if (!didTimeout) {
                        clearTimeout(timeout);
                        resolve(response);
                    }
                })
                    .catch((error) => {
                    if (!didTimeout) {
                        clearTimeout(timeout);
                        reject(error);
                    }
                });
            });
            // storedRequest will only not equal current Request if the timeout is hit
            fetchWrapperPromise.then((response) => {
                callback(null, response);
                this.tryProcessNextRequest();
            })
                .catch((error) => {
                callback(error, null);
                this.tryProcessNextRequest();
            });
        }
    }
}
//# sourceMappingURL=sequential-fetch-queue.js.map